// extracted by mini-css-extract-plugin
export var avatarContainer = "_ac-0";
export var avatarTypingWave = "_ac-i";
export var gray = "_ac-f";
export var green = "_ac-c";
export var icon = "_ac-9";
export var image = "_ac-1";
export var lg = "_ac-6";
export var md = "_ac-5";
export var presenceDot = "_ac-b";
export var red = "_ac-d";
export var sm = "_ac-4";
export var status = "_ac-a";
export var typingDot = "_ac-h";
export var typingPill = "_ac-g";
export var xl = "_ac-7";
export var xs = "_ac-3";
export var xxl = "_ac-8";
export var xxs = "_ac-2";
export var yellow = "_ac-e";